// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2y28B","colCheckbox":"styles_colCheckbox__21eVd"};